<template>
  <b-overlay :show="tableLoading" rounded="sm">
    <b-modal v-model="isModalVisible" id="message-modal" hide-footer class="pt-8" centered header-class="p-0"
      footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
      <template #modal-title>
        <div class="title-block text-center p-2">
          {{ $translate('monthly_activity_target_roll_up') }} - {{ modal_filters.month }} - {{ $translate('details') }}
        </div>
      </template>

      <div class="table-container">
        <div class="d-flex justify-content-end">
          <b-button id="export-checkoff-item-btn" variant="blue-icon" v-b-tooltip.hover :title="$translate('export')"
            @click="export_month_single()" v-if="hasPermissionCreate">
            <img src="@/assets/images/icon/export.svg" />
          </b-button>
        </div>
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Role/Officer</th>
              <th>Activity Type</th>
              <th>Target</th>
              <th>Actual</th>
            </tr>
            <tr>
              <th>
                <input type="hidden" v-model="modal_filters.month">
                <input type="hidden" v-model="modal_filters.type">
                <b-form-select v-custom-validation="$selectRequired()" value-field="name" text-field="name"
                  id="input-targets" v-model="modal_filters.selectedTarget" required :options="targets" class="w-auto">
                  <template #first>
                    <b-form-select-option :value="null" selected>
                      {{ $translate('select_targets') }}
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </th>
              <th>
                <!-- <input type="text" v-model="">
              <select v-model="modal_filters.selectedType" class="form-select w-auto" disabled>
                <option value="" selected>{{ $translate('select_type') }}</option>
                <option v-for="type in targets" :key="type.value" :value="type.value">{{ type.text }}</option>
              </select> -->
              </th>
              <th>
                <!-- <select v-model="modal_filters.selectedRole" class="form-select w-auto" disabled>
                <option value="" selected>{{ $translate('select_role') }}</option>
                <option v-for="role in roleOptions" :key="role.value" :value="role.value">{{ role.text }}</option>
              </select> -->
              </th>
              <th>
                <!-- Empty for future dropdowns or filtering -->
              </th>
              <th>
                <!-- Empty for future dropdowns or filtering -->
              </th>
              <th>
                <!-- Empty for future dropdowns or filtering -->
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in month_data" :key="data.id">
              <td>{{ data.name }}</td>
              <td>{{ data.target_type }}</td>
              <td v-if="data.role_name">
                {{ data.role_name }}
              </td>
              <td v-else-if="data.officer_name">
                {{ data.officer_name }}
              </td>
              <td v-else>
                -
              </td>
              <td>{{ data.activity_type_name }}</td>
              <td>
                <span v-if="data.target_type === 'count'">

                  {{ data.target_no_of_activity }}
                </span>
                <span v-if="data.target_type === 'value'">

                  {{ data.target_total_value }}
                </span>
              </td>
              <td>{{ data.actuals }}</td>
            </tr>
          </tbody>
        </table>


      </div>

    </b-modal>
    <b-modal v-model="isModalVisibleMonth" id="message-modal" hide-footer class="pt-8" centered header-class="p-0"
      footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap overflow-scroll-x"
      overflow-scroll>
      <template #modal-title>
        <div class="title-block text-center p-2">
          {{ $translate('monthly_target_roll_up_details') }}
        </div>
      </template>

      <div class="table-container">
        <div class="d-flex justify-content-end">
          <b-button id="export-checkoff-item-btn" variant="blue-icon" v-b-tooltip.hover :title="$translate('export')"
            @click="export_month_year()" v-if="hasPermissionCreate">
            <img src="@/assets/images/icon/export.svg" />
          </b-button>
        </div>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Name
                <table style="width: 100%; border-collapse: collapse;">
                  <tr>
                    <th>
                      <b-form-select v-custom-validation="$selectRequired()" value-field="name" text-field="name"
                        id="input-targets" v-model="modal_filters_officer.selectedTarget" required :options="targets"
                        class="w-auto">
                        <template #first>
                          <b-form-select-option :value="null" selected>
                            {{ $translate('select_targets') }}
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                    </th>

                  </tr>
                </table>

              </th>
              <th>Type
                <table style="width: 100%; border-collapse: collapse;">
                  <tr>
                    <th>
                      <b-form-select v-custom-validation="$selectRequired()" value-field="name" text-field="name"
                        id="input-targets" v-model="modal_filters_officer.selectedTargetType" required
                        :options="target_types" class="w-auto">
                        <template #first>
                          <b-form-select-option :value="null" selected>
                            {{ $translate('select_targets') }}
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                    </th>

                  </tr>
                </table>
              </th>
              <th>Role / Officer</th>
              <th v-for="month in unique_months" :key="month" style="width: 100%;">
                {{ month }}
                <table style="width: 100%; border-collapse: collapse;">
                  <tr>
                    <th style="text-align: center;">Target</th>
                    <th style="text-align: center;">Actuals</th>
                  </tr>
                </table>
              </th>

            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in months_data" :key="index">
              <td>{{ item.target_name }}</td>
              <td>{{ item.type }}</td>
              <td v-if="item.role">
                {{ item.role }}
              </td>
              <td v-else-if="item.officer">
                {{ item.officer }}
              </td>
              <td v-else>
                -
              </td>
              <td v-for="month in unique_months" :key="month" style="width: 100%;">
                <table style="width: 100%; border-collapse: collapse;">
                  <tr>
                    <td style="text-align: center;">
                      {{ item.months[month] ? item.months[month].target : '-' }}
                    </td>
                    <td style="text-align: center;">
                      {{ item.months[month] ? item.months[month].actuals : '-' }}
                    </td>
                  </tr>
                </table>
              </td>

            </tr>
          </tbody>
        </table>

      </div>

    </b-modal>
    <b-modal v-model="isModalVisibleOfficer" id="message-modal" hide-footer class="pt-8" centered header-class="p-0"
      footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
      <template #modal-title>
        <div class="title-block text-center p-2">
          {{ $translate('monthly_activity_target_roll_up') }} - {{ modal_filters_officer_officer.month }} - {{
            $translate('details') }}
        </div>
      </template>

      <div class="table-container">
        <div class="d-flex justify-content-end">
          <b-button id="export-checkoff-item-btn" variant="blue-icon" v-b-tooltip.hover :title="$translate('export')"
            @click="export_month_single_officer()" v-if="hasPermissionCreate">
            <img src="@/assets/images/icon/export.svg" />
          </b-button>
        </div>
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Role/Officer</th>
              <th>Activity Type</th>
              <th>Target</th>
              <th>Actual</th>
            </tr>
            <tr>
              <th>
                <input type="hidden" v-model="modal_filters_officer_officer.month">
                <input type="hidden" v-model="modal_filters_officer_officer.type">
                <b-form-select v-custom-validation="$selectRequired()" value-field="name" text-field="name"
                  id="input-targets" v-model="modal_filters_officer_officer.selectedTarget" required :options="targets"
                  class="w-auto">
                  <template #first>
                    <b-form-select-option :value="null" selected>
                      {{ $translate('select_targets') }}
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </th>
              <th>
                <!-- <input type="text" v-model="">
              <select v-model="modal_filters.selectedType" class="form-select w-auto" disabled>
                <option value="" selected>{{ $translate('select_type') }}</option>
                <option v-for="type in targets" :key="type.value" :value="type.value">{{ type.text }}</option>
              </select> -->
              </th>
              <th>
                <!-- <select v-model="modal_filters.selectedRole" class="form-select w-auto" disabled>
                <option value="" selected>{{ $translate('select_role') }}</option>
                <option v-for="role in roleOptions" :key="role.value" :value="role.value">{{ role.text }}</option>
              </select> -->
              </th>
              <th>
                <!-- Empty for future dropdowns or filtering -->
              </th>
              <th>
                <!-- Empty for future dropdowns or filtering -->
              </th>
              <th>
                <!-- Empty for future dropdowns or filtering -->
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in month_data_officer" :key="data.id">
              <td>{{ data.name }}</td>
              <td>{{ data.target_type }}</td>
              <td v-if="data.role_name">
                {{ data.role_name }}
              </td>
              <td v-else-if="data.officer_name">
                {{ data.officer_name }}
              </td>
              <td v-else>
                -
              </td>
              <td>{{ data.activity_type_name }}</td>
              <td>
                <span v-if="data.target_type === 'count'">

                  {{ data.target_no_of_activity }}
                </span>
                <span v-if="data.target_type === 'value'">

                  {{ data.target_total_value }}
                </span>
              </td>
              <td>{{ data.actuals }}</td>
            </tr>
          </tbody>
        </table>


      </div>

    </b-modal>
    <b-modal v-model="isModalVisibleMonthOfficer" id="message-modal" hide-footer class="pt-8" centered
      header-class="p-0" footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap"
      overflow-scroll>
      <template #modal-title>
        <div class="title-block text-center p-2">
          {{ $translate('activity_types') }}
        </div>
      </template>

      <div class="table-container">
        <div class="d-flex justify-content-end">
          <b-button id="export-checkoff-item-btn" variant="blue-icon" v-b-tooltip.hover :title="$translate('export')"
            @click="export_month_year_officer()" v-if="hasPermissionCreate">
            <img src="@/assets/images/icon/export.svg" />
          </b-button>
        </div>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Name
                <table style="width: 100%; border-collapse: collapse;">
                  <tr>
                    <th>
                      <b-form-select v-custom-validation="$selectRequired()" value-field="name" text-field="name"
                        id="input-targets" v-model="modal_filters_officer_officer_month.selectedTarget" required
                        :options="targets" class="w-auto">
                        <template #first>
                          <b-form-select-option :value="null" selected>
                            {{ $translate('select_targets') }}
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                    </th>

                  </tr>
                </table>

              </th>
              <th>Type
                <table style="width: 100%; border-collapse: collapse;">
                  <tr>
                    <th>
                      <b-form-select v-custom-validation="$selectRequired()" value-field="name" text-field="name"
                        id="input-targets" v-model="modal_filters_officer_officer_month.selectedTargetType" required
                        :options="target_types" class="w-auto">
                        <template #first>
                          <b-form-select-option :value="null" selected>
                            {{ $translate('select_targets') }}
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                    </th>

                  </tr>
                </table>
              </th>
              <th>Role / Officer</th>
              <th v-for="month in unique_months_officer" :key="month" style="width: 100%;">
                {{ month }}
                <table style="width: 100%; border-collapse: collapse;">
                  <tr>
                    <th style="text-align: center;">Target</th>
                    <th style="text-align: center;">Actuals</th>
                  </tr>
                </table>
              </th>

            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in months_data_officer" :key="index">
              <td>{{ item.target_name }}</td>
              <td>{{ item.type }}</td>
              <td v-if="item.role">
                {{ item.role }}
              </td>
              <td v-else-if="item.officer">
                {{ item.officer }}
              </td>
              <td v-else>
                -
              </td>
              <td v-for="month in unique_months_officer" :key="month" style="width: 100%;">
                <table style="width: 100%; border-collapse: collapse;">
                  <tr>
                    <td style="text-align: center;">
                      {{ item.months[month] ? item.months[month].target : '-' }}
                    </td>
                    <td style="text-align: center;">
                      {{ item.months[month] ? item.months[month].actuals : '-' }}
                    </td>
                  </tr>
                </table>
              </td>

            </tr>
          </tbody>
        </table>

      </div>

    </b-modal>
    <b-card class="inner-block health-listing">
      <b-card-header>

        <b-row class="mt-2">


          <b-col cols="12" v-if="entityIdx === 1" class="d-flex flex-column">
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-3">
              <div class="text-start me-3">
                <strong>{{ filters.selectedYear }} Activity Target:</strong><br />
                <span class="fs-6">{{ calculateTotals().total_activity_target }} Activities</span>
              </div>
              <div class="text-start me-3">
                <strong>{{ filters.selectedYear }} Value Target:</strong><br />
                <span class="fs-6">${{ calculateTotals().total_value_target }}</span>
                <!-- Ensure total_value_target is formatted correctly -->
              </div>

              <!-- <b-button id="export-checkoff-item-btn" variant="blue-icon" class="me-2" v-b-tooltip.hover
                :title="$translate('export')" @click="export_roster()" v-if="hasPermissionCreate">
                <img src="@/assets/images/icon/export.svg" />
              </b-button> -->

              <b-button variant="blue-icon" id="calender-view-btn" v-if="hasPermissionView" class="me-2"
                v-b-tooltip.hover :title="$translate('list_view')" @click="list_view()">
                <img src="@/assets/images/icon/activities.svg" />
              </b-button>
              <b-button variant="blue-icon" id="calender-view-btn" v-if="isAnyCheckboxChecked" class="me-2"
                v-b-tooltip.hover :title="$translate('view_modal')" @click="list_view_modal()">
                <img src="@/assets/images/icon/view.svg" />
              </b-button>
            </div>
            <div class="d-flex flex-wrap gap-3">
              <b-form-select v-custom-validation="$selectRequired()" value-field="id" text-field="name"
                id="input-activity_type" v-model="filters.activity_type" required :options="orderTypesArray"
                class="w-auto">
                <template #first>
                  <b-form-select-option :value="null" selected>
                    {{ $translate('select_activity_type') }}
                  </b-form-select-option>
                </template>
              </b-form-select>
              <b-form-select v-custom-validation="$selectRequired()" value-field="year" text-field="year"
                id="input-year" v-model="filters.selectedYear" required :options="yearOptions" class="w-auto">
                <template #first>
                  <b-form-select-option :value="null" selected>
                    {{ $translate('select_year') }}
                  </b-form-select-option>
                </template>
              </b-form-select>


              <b-form-select v-custom-validation="$selectRequired()" value-field="name" text-field="name"
                id="input-targets" v-model="filters.selectedTarget" required :options="targets" class="w-auto">
                <template #first>
                  <b-form-select-option :value="null" selected>
                    {{ $translate('select_targets') }}
                  </b-form-select-option>
                </template>
              </b-form-select>

            </div>



          </b-col>
          <b-col cols="12" v-if="entityIdx === 2" class="d-flex flex-column">
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-3">
              <div class="text-start me-3">
                <strong>{{ officer_filters.selectedYear }} Activity Target:</strong><br />
                <span class="fs-6">{{ calculateTotalsOfficer().total_activity_target }} Activities</span>
              </div>
              <div class="text-start me-3">
                <strong>{{ officer_filters.selectedYear }} Value Target:</strong><br />
                <span class="fs-6">${{ calculateTotalsOfficer().total_value_target }}</span>
                <!-- Ensure total_value_target is formatted correctly -->
              </div>

              <!-- <b-button id="export-checkoff-item-btn" variant="blue-icon" v-b-tooltip.hover
                :title="$translate('export')" @click="export_roster()" v-if="hasPermissionCreate" class="me-2">
                <img src="@/assets/images/icon/export.svg" />
              </b-button> -->

              <b-button variant="blue-icon" id="calender-view-btn" v-if="hasPermissionView" class="me-2"
                v-b-tooltip.hover :title="$translate('list_view')" @click="list_view()">
                <img src="@/assets/images/icon/activities.svg" />
              </b-button>
              <b-button variant="blue-icon" id="calender-view-btn" v-if="isAnyCheckboxCheckedOfficer" class="me-2"
                v-b-tooltip.hover :title="$translate('view_modal')" @click="list_view_modal_officer()">
                <img src="@/assets/images/icon/view.svg" />
              </b-button>
            </div>

            <!-- Filter Dropdowns in the next line -->
            <div class="d-flex flex-wrap gap-3">
              <b-form-select v-model="officer_filters.selectedRole" :options="roles" name="radios-stacked"
                text-field="name" value-field="id" class="w-auto">
                <template #first>
                  <b-form-select-option :value="null" selected>{{ $translate('select_role') }}</b-form-select-option>
                </template>
              </b-form-select>

              <b-form-select v-custom-validation="$selectRequired()" value-field="id" text-field="name"
                id="input-officers" v-model="officer_filters.selectedOfficer" required :options="officers"
                class="w-auto">
                <template #first>
                  <b-form-select-option :value="null" selected>
                    {{ $translate('select_officer') }}
                  </b-form-select-option>
                </template>
              </b-form-select>

              <b-form-select v-custom-validation="$selectRequired()" value-field="name" text-field="name"
                id="input-targets" v-model="officer_filters.selectedTarget" required :options="targets" class="w-auto">
                <template #first>
                  <b-form-select-option :value="null" selected>
                    {{ $translate('select_targets') }}
                  </b-form-select-option>
                </template>
              </b-form-select>

              <b-form-select v-custom-validation="$selectRequired()" value-field="year" text-field="year"
                id="input-year" v-model="officer_filters.selectedYear" required :options="yearOptions" class="w-auto">
                <template #first>
                  <b-form-select-option :value="null" selected>
                    {{ $translate('select_year') }}
                  </b-form-select-option>
                </template>
              </b-form-select>
            </div>
          </b-col>

        </b-row>

      </b-card-header>
      <b-card-body class="button-off">

        <div id="navbar-animmenu">
          <ul class="show-dropdown main-navbar">
            <div class="hori-selector" ref="selector" :style="{ width: divWidth, left: divLeft }">
              <div class="left"></div>
              <div class="right"></div>
            </div>
            <li v-for="item in entityOptions" :key="'entity' + item.value" :class="{ active: entityIdx === item.value }"
              @click="changeEntityIdx(item.value)">
              <a href="javascript:void(0);" :id="item.text">
                <i :class="getIcons[item.value]" aria-hidden="true"></i>
                {{ item.text }}
              </a>
            </li>
          </ul>

          <!-- Display different content based on selected tab -->

        </div>
        <div v-if="entityIdx === 1" class="content" style="padding-top:100px;">


          <div class="d-flex align-items-center">
            <b-form-checkbox v-model="selectAll" @change="toggleSelectAll" class="me-2"></b-form-checkbox>
            <label>Select All Months</label>
          </div>

          <b-row>
            <b-col v-for="(monthData, index) in year_data" :key="index" cols="12" md="6" lg="4" xl="3" class="mb-4">

              <b-card class="text-center square-card">
                <!-- First Row: Month Name -->
                <b-row class="mb-2 align-items-center">
                  <b-col class="text-start d-flex align-items-center">
                    <b-form-checkbox v-model="monthChecked[index]" class="me-2"></b-form-checkbox>
                    <h5 class="mb-0">{{ monthData.month }}</h5>
                  </b-col>
                </b-row>

                <!-- Second Row: Activity Count -->
                <b-row class="mb-3">
                  <b-col>
                    <div class="d-flex align-items-center">
                      <!-- Input field for activities count -->
                      <div class="me-2">
                        <input type="text" v-model="monthData.target_no_of_activity" readonly
                          class="form-control form-control-sm text-center"
                          style="width: 80px; height: 25px !important;" />
                      </div>
                      <!-- Activities Label -->
                      <span class="fw-bold text-decoration-underline"
                        @click="OpenMonthData(monthData.month, 'count')">Activities</span>

                    </div>
                  </b-col>
                </b-row>

                <!-- Third Row: Progress Bar -->
                <b-row>
                  <b-col cols="12">
                    <div class="d-flex align-items-center">
                      <!-- Progress bar with multiple sections -->
                      <div class="flex-grow-1 me-2">
                        <b-progress height="20px"
                          :max="monthData.completed_orders + (monthData.target_no_of_activity - monthData.completed_orders)"
                          show-value>
                          <b-progress-bar :value="monthData.completed_orders" style="background-color: #c1f1fd;">
                            <span style="font-size: 0.8em; font-weight: bold;color:#000000;">
                              {{ monthData.completed_orders }}
                            </span>
                          </b-progress-bar>
                          <b-progress-bar :value="monthData.target_no_of_activity - monthData.completed_orders"
                            style="background-color: #fb7289;">
                            <span style="font-size: 0.8em; font-weight: bold;">
                              {{ monthData.target_no_of_activity - monthData.completed_orders }}
                            </span>
                          </b-progress-bar>
                        </b-progress>
                      </div>

                      <!-- Percentage Value -->
                      <span style="font-size:10px;font-weight:bolder;">
                        {{ monthData.target_no_of_activity > 0 ? ((monthData.completed_orders * 100) /
                          monthData.target_no_of_activity).toFixed(2) : 0 }}%
                      </span>
                    </div>
                  </b-col>
                </b-row>


                <!-- Additional Progress Bar for Dollar Value -->
                <b-row class="mt-2">

                  <b-col>
                    <div class="d-flex align-items-center">
                      <!-- Input field for activities count -->
                      <div class="me-2">
                        <input type="text" :value="formatCurrency(monthData.target_total_value)" readonly
                          class="form-control form-control-sm text-center"
                          style="width: 80px; height: 25px !important;" />
                      </div>
                      <!-- Activities Label -->
                      <span @click="OpenMonthData(monthData.month, 'value')"
                        class="fw-bold text-decoration-underline">In
                        Values</span>
                    </div>
                  </b-col>

                  <b-col cols="12 mt-3">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1 me-2">
                        <b-progress height="20px" :max="monthData.target_total_value">
                          <b-progress-bar :value="monthData.total_price" style="background-color: #c1f1fd;">
                            <!-- Displaying dollar value directly -->
                            <span style="font-size: 0.8em; font-weight: bold;color:#000000;">
                              ${{ monthData.total_price }}
                            </span>
                          </b-progress-bar>
                          <b-progress-bar :value="monthData.target_total_value - monthData.total_price"
                            style="background-color: #fb7289;">
                            <span style="font-size: 0.8em; font-weight: bold;">
                              ${{ monthData.target_total_value - monthData.total_price }}
                            </span>
                          </b-progress-bar>
                        </b-progress>
                      </div>

                      <!-- Percentage Value -->
                      <span style="font-size:10px;font-weight:bolder;">
                        {{
                          Number(monthData.target_total_value) > 0
                            ? ((Number(monthData.total_price) * 100) / Number(monthData.target_total_value)).toFixed(2)
                            : 0
                        }}%
                      </span>
                    </div>
                  </b-col>

                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </div>

        <div v-if="entityIdx === 2" class="content" style="padding-top:100px;">
          <div class="d-flex align-items-center">
            <b-form-checkbox v-model="selectAllOfficer" @change="toggleSelectAllOfficer" class="me-2"></b-form-checkbox>
            <label>Select All Months</label>
          </div>

          <b-row>
            <b-col v-for="(monthData, index) in year_data_officer" :key="index" cols="12" md="6" lg="4" xl="3"
              class="mb-4">

              <b-card class="text-center square-card">
                <!-- First Row: Month Name -->
                <b-row class="mb-2">
                  <b-col class="text-start">
                    <b-form-checkbox v-model="monthCheckedOfficer[index]" class="me-2"></b-form-checkbox>
                    <h5>{{ monthData.month }}</h5>
                  </b-col>
                </b-row>

                <!-- Second Row: Activity Count -->
                <b-row class="mb-3">
                  <b-col>
                    <div class="d-flex align-items-center">
                      <!-- Input field for activities count -->
                      <div class="me-2">
                        <input type="text" v-model="monthData.target_no_of_activity" readonly
                          class="form-control form-control-sm text-center"
                          style="width: 80px; height: 25px !important;" />
                      </div>
                      <!-- Activities Label -->
                      <span @click="OpenMonthDataOfficer(monthData.month, 'count')"
                        class="fw-bold text-decoration-underline">Activities</span>
                    </div>
                  </b-col>
                </b-row>

                <!-- Third Row: Progress Bar -->
                <b-row>
                  <b-col cols="12">
                    <div class="d-flex align-items-center">
                      <!-- Progress bar with multiple sections -->
                      <div class="flex-grow-1 me-2">
                        <b-progress height="20px"
                          :max="monthData.completed_orders + (monthData.target_no_of_activity - monthData.completed_orders)"
                          show-value>
                          <b-progress-bar :value="monthData.completed_orders" style="background-color: #c1f1fd;">
                            <span style="font-size: 0.8em; font-weight: bold;color:#000000;">
                              {{ monthData.completed_orders }}
                            </span>
                          </b-progress-bar>
                          <b-progress-bar :value="monthData.target_no_of_activity - monthData.completed_orders"
                            style="background-color: #fb7289;">
                            <span style="font-size: 0.8em; font-weight: bold;">
                              {{ monthData.target_no_of_activity - monthData.completed_orders }}
                            </span>
                          </b-progress-bar>
                        </b-progress>
                      </div>

                      <!-- Percentage Value -->
                      <span style="font-size:10px;font-weight:bolder;">
                        {{ monthData.target_no_of_activity > 0 ? ((monthData.completed_orders * 100) /
                          monthData.target_no_of_activity).toFixed(2) : 0 }}%
                      </span>
                    </div>
                  </b-col>
                </b-row>


                <!-- Additional Progress Bar for Dollar Value -->
                <b-row class="mt-2">

                  <b-col>
                    <div class="d-flex align-items-center">
                      <!-- Input field for activities count -->
                      <div class="me-2">
                        <input type="text" :value="formatCurrency(monthData.target_total_value)" readonly
                          class="form-control form-control-sm text-center"
                          style="width: 80px; height: 25px !important;" />
                      </div>
                      <!-- Activities Label -->
                      <span class="fw-bold text-decoration-underline"
                        @click="OpenMonthDataOfficer(monthData.month, 'value')">In Values</span>
                    </div>
                  </b-col>

                  <b-col cols="12 mt-3">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1 me-2">
                        <b-progress height="20px"
                          :max="monthData.total_price + (monthData.target_total_value - monthData.total_price)">
                          <b-progress-bar :value="monthData.total_price" style="background-color: #c1f1fd;">
                            <!-- Displaying dollar value directly -->
                            <span style="font-size: 0.8em; font-weight: bold;color:#000000;">
                              ${{ monthData.total_price }}
                            </span>
                          </b-progress-bar>
                          <b-progress-bar :value="monthData.target_total_value - monthData.total_price"
                            style="background-color: #fb7289;">
                            <span style="font-size: 0.8em; font-weight: bold;">
                              ${{ monthData.target_total_value - monthData.total_price }}
                            </span>
                          </b-progress-bar>
                        </b-progress>
                      </div>

                      <!-- Percentage Value -->
                      <span style="font-size:10px;font-weight:bolder;">
                        {{
                          Number(monthData.target_total_value) > 0
                            ? ((Number(monthData.total_price) * 100) / Number(monthData.target_total_value)).toFixed(2)
                            : 0
                        }}%
                      </span>
                    </div>
                  </b-col>

                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>
<script>
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import TargetsFilters from './TargetsFilters.vue'
import importMixins from "@/mixins/importMixins";
import ImportForm from "@/components/ImportForm.vue";
import PageActions from "@/components/PageActions.vue";
import dropdownIcon1 from "@/assets/images/icon/i-1.svg";
import dropdownIcon2 from "@/assets/images/icon/i-2.svg";
import dropdownIcon3 from "@/assets/images/icon/i-3.svg";
import dropdownIcon4 from "@/assets/images/icon/i-4.svg";
import dropdownIcon5 from "@/assets/images/icon/i-5.svg";
import dropdownIcon6 from "@/assets/images/icon/i-6.svg";
import dropdownIcon7 from "@/assets/images/icon/i-7.svg";
import targets from '../../api/targets';
import { months } from 'moment';

const inventoryFields = [
  { name: "name", label: "name", required: true, type: "text" },
  { name: "month_year", label: "month_year", required: true, type: "text" },

  {
    name: "activity_type",
    label: "activity_type",
    required: true,
    type: "text",
  },
  { name: "target_type", label: "target_type", required: true, type: "text" },

  {
    name: "target_no_of_activity",
    label: "target_no_of_activity",
    required: false,
    type: "number",
  },
  {
    name: "target_total_value",
    label: "target_total_value",
    required: false,
    type: "number",
  },
  {
    name: "role",
    label: "role",
    required: false,
    type: "text",
  },
  {
    name: "officer",
    label: "officer",
    required: false,
    type: "text",
  },
  {
    name: "agent",
    label: "agent",
    required: false,
    type: "text",
  },
  {
    name: "customer_segment",
    label: "customer_segment",
    required: false,
    type: "text",
  },
  {
    name: "customer_group",
    label: "customer_group",
    required: false,
    type: "text",
  },
  {
    name: "interaction_type",
    label: "interaction_type",
    required: false,
    type: "text",
  },




];
export default {
  name: 'health-table',
  mixins: [popupMixins, permissionsMixins, importMixins],
  components: {
    TargetsFilters,
    ImportForm,
    PageActions

  },
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      selectedOrders: [],
      query: '',
      tableLoading: false,
      toggle_filters: false,
      filters: {
        selectedYear: new Date().getFullYear(),
        activity_type: null,
        selectedTarget: null,
      },
      officer_filters: {
        selectedYear: new Date().getFullYear(),
        selectedRole: null,
        selectedOfficer: null,
        selectedTarget: null
      },
      importModal: false,
      inventoryFields,
      isTarget: 'yes',
      activityTypes: [],
      isModalVisible: false,
      isModalVisibleOfficer: false,
      entityIdx: 1, // Default to "Company" tab
      divWidth: "160px", // Placeholder for selector width
      divLeft: "0px", // Placeholder for selector position
      entityOptions: [
        { value: 1, text: "Company" },
        { value: 2, text: "Officer" },
      ],
      yearOptions: this.generateYearOptions(),
      monthName: 'October', // Change it dynamically based on the data
      activitiesCount: 89,  // Total number of activities
      doneActivities: 70,   // Number of completed activities
      value: 45,
      max: 100,
      year_data: [],
      year_data_officer: [],
      month_data: [],
      month_data_officer: [],
      months_data: [],
      months_data_officer: [],
      fields: ['name', 'type', 'role', 'activity_type', 'target', 'actual'],
      modal_filters: {
        selectedTarget: null,
      },
      monthChecked: Array(12).fill(false),
      monthCheckedOfficer: Array(12).fill(false),
      isModalVisibleMonth: false,
      isModalVisibleMonthOfficer: false,
      unique_months: null,
      unique_months_officer: null,
      selectAll: false,
      selectAllOfficer: false,
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      target_types: {
        value: 'value',
        count: 'count'
      },
      modal_filters_officer: {
        selectedTargetType: null,
        selectedTarget: null
      },
      modal_filters_officer_officer: {
        selectedTarget: null,
      },
      modal_filters_officer_officer_month: {
        selectedTargetType: null,
        selectedTarget: null
      },

    }
  },
  computed: {
    isAnyCheckboxChecked() {
      // Check if any checkbox is selected
      return this.monthChecked.some(checked => checked);
    },
    isAnyCheckboxCheckedOfficer() {
      // Check if any checkbox is selected
      return this.monthCheckedOfficer.some(checked => checked);
    },
    orderTypesArray() {
      return this.$store.getters["orderType/activityTypesByPermission"];
    },
    officers() {
      return (this.$store.state.orders.drivers || []).map((x) => ({
        id: x.id,
        name: `${x.first_name} ${x.last_name}`.trim(),
      }));
    },
    getIcons() {
      return {
        1: "fa fa-building", // Icon for Company
        2: "fa fa-user",     // Icon for Officer
      };
    },
    pageCount() {
      return Math.ceil(this.pagination.total / this.pagination.pageSize)
    },
    targets() {
      const targets = this.$store.state.targets.items_not_paginated

      return targets
    },
    roles() {
      return this.$store.state.roles.items;
    },
    pagination() {
      return this.$store.state.targets.pagination || { page: 1 }
    },

    otherActions() {
      const actions = [];

      actions.push(
        {
          action: () => this.duplicate_target(),
          icon: dropdownIcon2,
          text: this.$translate("duplicate_target"),

        },
        {
          action: () => this.view_analytics(),
          icon: dropdownIcon2,
          text: this.$translate("view_analytics"),

        },
        // {
        //   action: () => this.generate_report(),
        //   icon: dropdownIcon2,
        //   text: this.$translate("generate_report"),

        // },
        {
          action: () => this.bulk_delete(),
          icon: dropdownIcon7,
          text: this.$translate("delete"),

        },

      );



      return actions;
    },


  },

  watch: {
    targets: {
      handler: function () {
        this.tableLoading = false
      },
      deep: true,
    },
    'pagination.page': function (newPage) {
      this.changePage(newPage)
    },
    query: _.debounce(function (query) {
      this.$router.push({ query: { query } })
      this.doSearch()
    }, 200),
    filters: {
      handler: function () {

        this.fetch_year_data()
      },
      deep: true,
    },
    officer_filters: {
      handler: function () {

        this.fetch_year_data()
      },
      deep: true,

    },
    modal_filters: {
      handler: function () {

        this.fetch_modal_data_month()
      },
      deep: true,

    },
    modal_filters_officer: {
      handler: function () {

        this.fetch_modal_data_months()
      },
      deep: true,

    },
    modal_filters_officer_officer: {
      handler: function () {

        this.fetch_modal_data_month_officer()
      },
      deep: true,

    },
    modal_filters_officer_officer_month: {
      handler: function () {

        this.fetch_modal_data_months_officer()
      },
      deep: true,

    },
    entityIdx: {
      handler: function () {

        this.fetch_year_data()
      },
      deep: true,
    }
  },

  async created() {
    await Promise.all([
      this.$store.dispatch("orderType/fetchAll"),
      this.$store.dispatch("roles/fetchAll"),
      this.$store.dispatch("orders/fetchDriversNew"),
      this.$store.dispatch("customerAgents/fetchAll"),
      this.$store.dispatch("interactionType/fetchAll"),
      this.$store.dispatch('customerSegments/fetchAll'),
      this.$store.dispatch('customerGroups/fetchAll'),
      this.$store.dispatch('targets/fetchAll'),


    ]);
  },
  async mounted() {


    await this.fetch_year_data();

  },

  methods: {
    toggleSelectAll() {
      // If "Select All" is checked, set all to true, otherwise set all to false
      this.monthChecked = this.selectAll ? this.months.map(() => true) : this.months.map(() => false);
    },
    toggleSelectAllOfficer() {
      // If "Select All" is checked, set all to true, otherwise set all to false
      this.monthCheckedOfficer = this.selectAllOfficer ? this.months.map(() => true) : this.months.map(() => false);
    },
    list_view() {
      this.$router.push({ name: 'Targets' });
    },
    async bulk_delete() {
      try {
        const title = this.$translate("delete_target_title");
        const message = this.$translate(`delete_target_note`);

        const result = await this.confirmMessage(title, message);
        console.log("result", result);
        if (!result) return false; //throw new Error("");

        this.tableLoading = true;
        await this.$store.dispatch("targets/bulkDelete", {
          targets: this.selectedOrders,
        });

        this.doToast(
          this.$translate("success"),
          this.$translate("bulk_target_delete"),
          "success"
        );

        await this.doSearch();
      } catch (err) {
        console.error(err);
        this.doToast(
          this.$translate("error"),
          this.$translate("bulk_target_delete_error"),
          "danger"
        );
      } finally {
        this.clearSelected();
        this.doSearch(true);
        this.tableLoading = false;
      }
    },
    generate_report() {

    },
    view_analytics() {

    },
    async duplicate_target() {
      try {


        this.tableLoading = true;
        await this.$store.dispatch("targets/duplicate", {
          targets: this.selectedOrders,
        });

        this.doToast(
          this.$translate("success"),
          this.$translate("bulk_target_duplicate"),
          "success"
        );

        await this.doSearch();
      } catch (err) {
        console.error(err);
        this.doToast(
          this.$translate("error"),
          this.$translate("bulk_target_duplicate_error"),
          "danger"
        );
      } finally {
        this.clearSelected();
        this.doSearch(true);
        this.tableLoading = false;
      }

    },
    clearSelected() {
      this.$refs.selectableTable && this.$refs.selectableTable.clearSelected();
    },
    onRowSelected(items) {
      this.selectedOrders = items;
    },
    toggleRow(index, rowSelected) {
      // Rows are indexed from 0, so the third row is index 2
      if (rowSelected) this.$refs.selectableTable.unselectRow(index);
      else this.$refs.selectableTable.selectRow(index);
    },

    toggleAllRow() {
      if (this.targets.length === this.selectedOrders.length)
        this.$refs.selectableTable.clearSelected();
      else this.$refs.selectableTable.selectAllRows();
    },

    changePage(page) {
      this.$router.push({ query: { page } })
      this.doSearch()
    },
    resetFilters() {
      this.setDefaultDateRange();
      this.doSearch()
    },
    async doSearch() {
      let type = "";
      if (this.filters.type && this.filters.type.length > 0 && Array.isArray(this.filters.type)) {
        type = this.filters.type.map((i) => i.id).join(",");
      }

      let role = "";
      if (this.filters.role && this.filters.role.length > 0 && Array.isArray(this.filters.role)) {
        role = this.filters.role.map((i) => i.id).join(",");
      }

      let officer = "";
      if (this.filters.officer && this.filters.officer.length > 0 && Array.isArray(this.filters.officer)) {
        officer = this.filters.officer.map((i) => i.id).join(",");
      }

      let agent = "";
      if (this.filters.agent && this.filters.agent.length > 0 && Array.isArray(this.filters.agent)) {
        agent = this.filters.agent.map((i) => i.id).join(",");
      }
      let customer_segment = "";
      if (this.filters.customer_segment && this.filters.customer_segment.length > 0 && Array.isArray(this.filters.customer_segment)) {
        customer_segment = this.filters.customer_segment.map((i) => i.id).join(",");
      }

      let interaction_type = "";
      if (this.filters.interaction_type && this.filters.interaction_type.length > 0 && Array.isArray(this.filters.interaction_type)) {
        interaction_type = this.filters.interaction_type.map((i) => i.id).join(",");
      }

      let customer_group = "";
      if (this.filters.customer_group && this.filters.customer_group.length > 0 && Array.isArray(this.filters.customer_group)) {
        customer_group = this.filters.customer_group.map((i) => i.id).join(",");
      }


      try {
        this.$store.commit('targets/updateFilter', {
          query: this.query,
          filters: { ...this.filters, type: type, role: role, officer: officer, agent: agent, customer_segment: customer_segment, interaction_type: interaction_type, customer_group: customer_group }
        });
        this.tableLoading = true
        const {
          pagination: { page },
          query,
          filters
        } = this
        await this.$store.dispatch('targets/fetch', {
          query,
          page,
          filters: { ...filters, type: type, role: role, officer: officer, agent: agent, customer_segment: customer_segment, interaction_type: interaction_type, customer_group: customer_group }
        })
      } catch (error) {
        console.error('loading error', error)
      }
    },
    view(index) {
      const path = `${this.$route.path}/${index}`
      console.log('path---', path);
      this.$router.push({ path })
    },

    truncate(text, length) {
      return _.truncate(text, { length: length })
    },
    addBudget() {
      const id = 0
      this.$router.push({ params: { id }, name: 'viewTarget' })
    },

    openModel() {

      this.importModal = true;
    },
    async export_roster() {

      this.tableLoading = true
      let filter_target = this.$store.state.targets.filter;
      let query_target = this.$store.state.targets.query;

      console.log('query-filter', filter_target);
      await this.$store.dispatch('targets/exportExcelCSV', {

        query_target,
        filter_target
      })
      this.tableLoading = false
    },
    setDefaultDateRange() {
      const currentDate = new Date();
      const currentDay = currentDate.getDay();
      const diffToSunday = currentDay === 0 ? 0 : 7 - currentDay;

      // Calculate the start date (two Sundays ago)
      const startDate = new Date(currentDate);
      startDate.setDate(currentDate.getDate() - currentDay + diffToSunday - 7);

      // Calculate the end date (next Saturday)
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 13);

      // Format dates to YYYY-MM-DD for the date input fields
      const formatDate = (date) => {
        return date.toISOString().split('T')[0];
      };

      this.filters.start_date = formatDate(startDate);
      this.filters.end_date = formatDate(endDate);
      const defaultStartTime = '10:00'; // Default start time
      const defaultEndTime = '19:00'; // Default end time
      this.filters.filter_date = formatDate(currentDate); // Set current date as the filter date
      this.filters.start_time = defaultStartTime;
      this.filters.end_time = defaultEndTime;
    },

    showModal(activityTypes) {
      this.activityTypes = activityTypes; // Set the activity types to display in the modal
      this.isModalVisible = true; // Show the modal
    },
    resetModal() {
      this.activityTypes = []; // Reset activity types when modal is closed
    },
    formatMonthYear(monthYearString) {
      const [year, month] = monthYearString.split('-'); // Split the string into year and month
      const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ]; // Array of month names
      const monthIndex = parseInt(month) - 1; // Convert month to index (0-11)
      return `${monthNames[monthIndex]}-${year}`; // Return formatted string
    },

    changeEntityIdx(value) {
      this.entityIdx = value;
      // Update selector position and width dynamically based on the selected item
      this.updateSelector(value);
    },
    updateSelector(value) {
      // Logic for updating `divWidth` and `divLeft`
      // This is just a placeholder for visual effects
      if (value === 1) {
        this.divWidth = "160px";
        this.divLeft = "20px";
      } else if (value === 2) {
        this.divWidth = "160px";
        this.divLeft = "188px";
      }
    },
    generateYearOptions() {
      const currentYear = new Date().getFullYear();
      const startYear = 1900; // You can change the start year
      const years = [];

      for (let year = currentYear; year >= startYear; year--) {
        years.push({ year });
      }

      return years;
    },
    randomValue() {
      this.value = Math.random() * this.max
    },
    async fetch_year_data() {
      this.tableLoading = true;
      console.log('this is entityIdx', this.entityIdx);
      console.log('this is filter', this.filters);
      if (this.entityIdx == 1) {
        await this.$store.dispatch('targets/getYearRecord', {
          filter: this.filters
        });
        this.year_data = this.$store.state.targets.monthly_record_company;
      }
      if (this.entityIdx == 2) {
        await this.$store.dispatch('targets/getYearRecordOfficer', {
          filter: this.officer_filters
        });
        this.year_data_officer = this.$store.state.targets.monthly_record_officer;
      }
      this.tableLoading = false;

    },
    formatCurrency(value) {
      // Format the number as currency with commas
      return `$${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    },

    calculateTotals() {
      const targets = this.year_data; // Get targets from year_data

      // Initialize totals
      let total_activity_target = 0;
      let total_value_target = 0;

      // Calculate totals
      // Calculate totals
      targets.forEach(target => {
        total_activity_target += parseInt(target.target_no_of_activity || 0); // Aggregate activity targets
        total_value_target += parseFloat(target.target_total_value || 0);      // Aggregate total values
      });

      // Format totals to 2 decimal points

      total_value_target = parseFloat(total_value_target).toFixed(2);

      // Return the calculated totals
      return {
        total_activity_target,
        total_value_target,
      };
    },
    calculateTotalsOfficer() {
      const targets = this.year_data_officer; // Get targets from year_data

      // Initialize totals
      let total_activity_target = 0;
      let total_value_target = 0;

      // Calculate totals
      // Calculate totals
      targets.forEach(target => {
        total_activity_target += parseInt(target.target_no_of_activity || 0); // Aggregate activity targets
        total_value_target += parseFloat(target.target_total_value || 0);      // Aggregate total values
      });

      // Format totals to 2 decimal points

      total_value_target = parseFloat(total_value_target).toFixed(2);

      // Return the calculated totals
      return {
        total_activity_target,
        total_value_target,
      };
    },
    async OpenMonthData(month, type) {

      await this.$store.dispatch('targets/getModelDataForMonth', {
        filter: { ...this.filters, month, type }
      });
      this.month_data = this.$store.state.targets.month_data;
      this.modal_filters.month = month;
      this.modal_filters.type = type;
      this.isModalVisible = true;

    },
    async OpenMonthDataOfficer(month, type) {

      await this.$store.dispatch('targets/getModelDataForMonthOfficer', {
        filter: { ...this.officer_filters, month, type }
      });
      this.month_data_officer = this.$store.state.targets.month_data_officer;
      this.modal_filters_officer_officer.month = month;
      this.modal_filters_officer_officer.type = type;
      this.isModalVisibleOfficer = true;

    },
    async fetch_modal_data_month() {
      var month = this.modal_filters.month;
      var type = this.modal_filters.type;
      var target_name = this.modal_filters.selectedTarget;
      await this.$store.dispatch('targets/getModelDataForMonth', {
        filter: { ...this.filters, month, type, target_name }
      });
      this.month_data = this.$store.state.targets.month_data;

      this.isModalVisible = true;

    },
    async export_month_single() {

      var month = this.modal_filters.month;
      var type = this.modal_filters.type;
      var target_name = this.modal_filters.selectedTarget;
      await this.$store.dispatch('targets/getModelDataForMonthExcel', {
        filter: { ...this.filters, month, type, target_name }
      });
      this.month_data = this.$store.state.targets.month_data;

    },
    async export_month_single_officer() {

      var month = this.modal_filters_officer_officer.month;
      var type = this.modal_filters_officer_officer.type;
      var target_name = this.modal_filters_officer_officer.selectedTarget;
      await this.$store.dispatch('targets/getModelDataForMonthOfficerExcel', {
        filter: { ...this.filters, month, type, target_name }
      });

    },
    async export_month_year() {

      const selectedMonths = this.year_data
        .map((monthData, index) => (this.monthChecked[index] ? monthData.month : null))
        .filter(month => month !== null);
      await this.$store.dispatch('targets/getModelDataByMonthExcel', {
        filter: { ...this.filters, selectedMonths, ...this.modal_filters_officer }
      });

    },
    async export_month_year_officer() {

      const selectedMonths = this.year_data_officer
        .map((monthData, index) => (this.monthCheckedOfficer[index] ? monthData.month : null))
        .filter(month => month !== null);
      await this.$store.dispatch('targets/getModelDataByMonthOfficerExcel', {
        filter: { ...this.officer_filters, selectedMonths, ...this.modal_filters_officer_officer_month }
      });

    },
    async fetch_modal_data_month_officer() {


      var month = this.modal_filters_officer_officer.month;
      var type = this.modal_filters_officer_officer.type;
      var target_name = this.modal_filters_officer_officer.selectedTarget;
      await this.$store.dispatch('targets/getModelDataForMonthOfficer', {
        filter: { ...this.filters, month, type, target_name }
      });

      this.month_data_officer = this.$store.state.targets.month_data_officer;



    },
    async list_view_modal() {
      const selectedMonths = this.year_data
        .map((monthData, index) => (this.monthChecked[index] ? monthData.month : null))
        .filter(month => month !== null);
      await this.$store.dispatch('targets/getModelDataByMonth', {
        filter: { ...this.filters, selectedMonths }
      });

      this.months_data = this.$store.state.targets.months_data;

      const monthsSet = new Set();
      this.months_data.forEach((item) => {
        Object.keys(item.months).forEach((month) => {
          monthsSet.add(month);
        });
      });
      this.unique_months = Array.from(monthsSet);
      this.isModalVisibleMonth = true;
    },
    async list_view_modal_officer() {
      const selectedMonths = this.year_data_officer
        .map((monthData, index) => (this.monthCheckedOfficer[index] ? monthData.month : null))
        .filter(month => month !== null);
      await this.$store.dispatch('targets/getModelDataByMonthOfficer', {
        filter: { ...this.officer_filters, selectedMonths }
      });

      this.months_data_officer = this.$store.state.targets.months_data_officer;

      const monthsSet = new Set();
      this.months_data_officer.forEach((item) => {
        Object.keys(item.months).forEach((month) => {
          monthsSet.add(month);
        });
      });
      this.unique_months_officer = Array.from(monthsSet);
      this.isModalVisibleMonthOfficer = true;
    },
    async fetch_modal_data_months() {
      const selectedMonths = this.year_data
        .map((monthData, index) => (this.monthChecked[index] ? monthData.month : null))
        .filter(month => month !== null);
      await this.$store.dispatch('targets/getModelDataByMonth', {
        filter: { ...this.filters, selectedMonths, ...this.modal_filters_officer }
      });

      this.months_data = this.$store.state.targets.months_data;

      const monthsSet = new Set();
      this.months_data.forEach((item) => {
        Object.keys(item.months).forEach((month) => {
          monthsSet.add(month);
        });
      });
      this.unique_months = Array.from(monthsSet);
    },
    async fetch_modal_data_months_officer() {
      console.log('this iscalledddd');
      const selectedMonths = this.year_data_officer
        .map((monthData, index) => (this.monthCheckedOfficer[index] ? monthData.month : null))
        .filter(month => month !== null);
      await this.$store.dispatch('targets/getModelDataByMonthOfficer', {
        filter: { ...this.officer_filters, selectedMonths, ...this.modal_filters_officer_officer_month }
      });

      this.months_data_officer = this.$store.state.targets.months_data_officer;
      console.log('this is month data ============', this.months_data_officer);
      const monthsSet = new Set();
      this.months_data_officer.forEach((item) => {
        Object.keys(item.months).forEach((month) => {
          monthsSet.add(month);
        });
      });
      this.unique_months_officer = Array.from(monthsSet);
    }
  },

}
</script>
<style scoped>
.role-badge-container {
  display: flex;
  flex-wrap: wrap;
  /* Allow wrapping to the next line */
  gap: 8px;
  /* Adjust space between the badges */
}

.role-badge {
  flex-basis: calc(25% - 8px);
  /* Each badge takes 25% width, minus the gap */
  text-align: center;
  /* Center align text within each badge */
  white-space: nowrap;
  /* Prevent text from wrapping inside badge */
}

.square-card {
  width: 200px;
  height: 200px;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.progress {
  border-radius: 10px;
  border: 1px solid;
  height: 12px !important;
}

.modal-body {

  overflow-x: scroll !important;
}

.overflow-scroll-x {
  overflow-x: scroll !important;
  /* Enables horizontal scroll */

}

.table-container {
  max-width: 100%;
  overflow-x: auto;
  /* Enable horizontal scrolling */
}

.table-container table {
  width: 100%;
  white-space: nowrap;
  /* Prevent table content from wrapping */
}

.table {
  /* Ensuring the table is displayed correctly */
  position: relative;
  width: 100%;
  border-collapse: collapse; /* Optional: for better appearance */
}

.table th, .table td {
  /* Ensuring proper padding and alignment */
  padding: 8px;
  text-align: left; /* or center as needed */
}

/* Make the first column sticky */
.table th:first-child,
.table td:first-child {
  position: sticky;
  left: 0; /* Positioning the sticky element */
  background-color: white; /* Background color for sticky element */
  z-index: 10; /* Ensuring it sits above other content */
  box-shadow: 2px 0 5px rgba(0,0,0,0.1); /* Optional shadow for better visibility */
}

</style>
